export default __webpack_public_path__ + "static/media/file-and-apple.f7802234.svg";